<template>
  <div class="app-step-two-tabs-credits">
    <div class="app-step-two-tabs__wrapper">
      <div class="app-step-two-tabs-credits__body">
        <div class="app-step-two-tabs-credits__line"><line-icon /></div>
        <h6 class="app-step-two-tabs-credits__title">
          You have <b> {{ totalCredits }} unused</b> distribution
          <b>credits</b> available.
        </h6>
        <div
          v-if="clientCredits?.data?.length"
          class="app-step-two-tabs-credits-table"
        >
          <ul class="app-step-two-tabs-credits-table__list">
            <li
              v-for="(credit, index) in clientCredits?.data"
              :key="credit.id"
              class="app-step-two-tabs-credits-table__item app-step-two-tabs-credits-table-item"
            >
              <div
                class="app-step-two-tabs-credits-table-item__name app-step-two-tabs-credits-table-item__name--title"
              >
                <div class="app-step-two-tabs-credits-table__title">
                  <h5>Package</h5>
                </div>
                <p>
                  <span>{{ index + 1 }}.</span> {{ credit?.package?.name }}
                </p>
              </div>
              <div
                class="app-step-two-tabs-credits-table-item__data app-step-two-tabs-credits-table-item__data--title"
              >
                <div class="app-step-two-tabs-credits-table__title">
                  <h5>Expiration Date</h5>
                </div>
                <div>
                  <p>{{ moment(credit.expiration).format('YYYY MMM DD') }}</p>
                  <span v-if="isExpired(credit.expiration)">Expired</span>
                </div>
              </div>
              <div
                class="app-step-two-tabs-credits-table-item__purchase app-step-two-tabs-credits-table-item__purchase--title"
              >
                <div
                  class="app-step-two-tabs-credits-table__title visibility-hidden"
                >
                  <h5>Hidden</h5>
                </div>

                <span v-if="credit.used"> Credit is already used </span>
                <button
                  v-else-if="credit.isExpired"
                  :disabled="isLoading"
                  @click="handlePurchaseCreditExtension(credit.id)"
                >
                  Purchase Credit Extension
                </button>
                <button v-else @click="handleRedeemCredit(credit.id)">
                  Redeem Credit
                </button>
              </div>
            </li>
          </ul>

          <app-pagination
            :page="currentPage"
            :last-page="lastPage"
            :total-pages="total"
            @changePage="changePage"
          ></app-pagination>
        </div>
      </div>
    </div>

    <navigation-buttons
      :loading="isLoading"
      :disabled-outer-condition="isLoading"
      @onNextButtonClick="
        updateOrder({ ...getFrontendTabBuilder(true) }, () => navigate(true))
      "
    ></navigation-buttons>
  </div>
</template>

<script setup>
import LineIcon from '@/assets/svg/line.svg?component'
import NavigationButtons from '@modules/app-steps/step-two/navigation-buttons/index.vue'
import moment from 'moment'

import { watch, computed } from 'vue'
import {
  total,
  lastPage,
  currentPage,
  changePage,
  useClientCredits,
} from '@core/composables/useClientCredits'
import { useOrder } from '@core/composables/order/useOrder'
import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'
import { useTabsStore } from '@/stores/tabs'
import { storeToRefs } from 'pinia'
import AppPagination from '@modules/ui/app-pagination.vue'
import { useOrderStore } from '@/stores/order'
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'

const { useUpdateOrder } = useOrder()
const { isLoading: isOrderUpdating, updateOrder } = useUpdateOrder()
const { navigate } = useNavigationButtons()
const { getFrontendTabBuilder } = storeToRefs(useTabsStore())

const orderStore = useOrderStore()

let {
  clientCredits,
  totalCredits,
  getClientCredits,
  isExpired,
  redeemCredit,
  purchaseCreditExtension,
  isClientCreditsLoading,
} = useClientCredits()

const isLoading = computed(
  () => isClientCreditsLoading.value || isOrderUpdating.value
)

const handleRedeemCredit = (creditId) => {
  return redeemCredit(creditId).then(() =>
    orderStore.setOrderType(OrderTypes.RedeemedCredit)
  )
}

const handlePurchaseCreditExtension = (creditId) => {
  return purchaseCreditExtension(creditId).then(() =>
    orderStore.setOrderType(OrderTypes.CreditExtension)
  )
}

watch(currentPage, (page) => {
  getClientCredits({ params: { page } })
})
</script>
